import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22c38e66"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-layout"
};
const _hoisted_2 = {
  class: "layout-content"
};
const _hoisted_3 = {
  class: "content-l"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = {
  class: "content-r"
};
const _hoisted_7 = {
  class: "language"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-en"
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "English", -1));
const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-tw"
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "繁體", -1));
const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-hin"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "हिन्दी", -1));
const _hoisted_17 = [_hoisted_15, _hoisted_16];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-fr"
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Francés", -1));
const _hoisted_20 = [_hoisted_18, _hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-span"
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Español", -1));
const _hoisted_23 = [_hoisted_21, _hoisted_22];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-de"
}, null, -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Deutsch", -1));
const _hoisted_26 = [_hoisted_24, _hoisted_25];
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-it"
}, null, -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Italiano", -1));
const _hoisted_29 = [_hoisted_27, _hoisted_28];
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-th"
}, null, -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "แบบไทย", -1));
const _hoisted_32 = [_hoisted_30, _hoisted_31];
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-pt"
}, null, -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Português", -1));
const _hoisted_35 = [_hoisted_33, _hoisted_34];
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-tr"
}, null, -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Türkçe", -1));
const _hoisted_38 = [_hoisted_36, _hoisted_37];
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-kr"
}, null, -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "한국인", -1));
const _hoisted_41 = [_hoisted_39, _hoisted_40];
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-jp"
}, null, -1));
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日本語", -1));
const _hoisted_44 = [_hoisted_42, _hoisted_43];
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-ru"
}, null, -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pусский", -1));
const _hoisted_47 = [_hoisted_45, _hoisted_46];
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-ar"
}, null, -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "اللغة العربية", -1));
const _hoisted_50 = [_hoisted_48, _hoisted_49];
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-nl"
}, null, -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Dutch", -1));
const _hoisted_53 = [_hoisted_51, _hoisted_52];
import { ref } from 'vue';
// import router from '@/router'
import store from '@/store';
// import { GlobalOutlined } from '@ant-design/icons-vue'
import { useI18n } from "vue-i18n";
import HeaderNav from '@/components/HeaderNav.vue';
export default {
  __name: 'LoginLayout',
  emits: ['toggleDayNight'],
  setup(__props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const {
      setLocaleMessage,
      locale
    } = useI18n();
    const changeColor = checked => {
      emit('toggleDayNight', checked);
    };
    const languageModel = ref(false);
    const langSelcet = lang => {
      localStorage.setItem('pcsetlang', lang);
      store.commit('langChange', lang);
      try {
        const msg = require(`@/language/lang/${lang}`).default;
        setLocaleMessage(lang, msg);
        locale.value = lang;
      } catch (err) {
        console.warn(err);
      }
      languageModel.value = false;
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(HeaderNav, {
        onChangeColor: changeColor
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('loginLayoutText')), 1)])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_router_view, {
        style: {
          "width": "100%"
        }
      })])]), _createVNode(_component_a_modal, {
        visible: languageModel.value,
        "onUpdate:visible": _cache[15] || (_cache[15] = $event => languageModel.value = $event),
        footer: null
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('homeremind63')), 1), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'en'
          }]),
          onClick: _cache[0] || (_cache[0] = $event => langSelcet('en'))
        }, _hoisted_11, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'tc'
          }]),
          onClick: _cache[1] || (_cache[1] = $event => langSelcet('tc'))
        }, _hoisted_14, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'hin'
          }]),
          onClick: _cache[2] || (_cache[2] = $event => langSelcet('hin'))
        }, _hoisted_17, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'fr'
          }]),
          onClick: _cache[3] || (_cache[3] = $event => langSelcet('fr'))
        }, _hoisted_20, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'span'
          }]),
          onClick: _cache[4] || (_cache[4] = $event => langSelcet('span'))
        }, _hoisted_23, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'de'
          }]),
          onClick: _cache[5] || (_cache[5] = $event => langSelcet('de'))
        }, _hoisted_26, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'it'
          }]),
          onClick: _cache[6] || (_cache[6] = $event => langSelcet('it'))
        }, _hoisted_29, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'th'
          }]),
          onClick: _cache[7] || (_cache[7] = $event => langSelcet('th'))
        }, _hoisted_32, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'pt'
          }]),
          onClick: _cache[8] || (_cache[8] = $event => langSelcet('pt'))
        }, _hoisted_35, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'tr'
          }]),
          onClick: _cache[9] || (_cache[9] = $event => langSelcet('tr'))
        }, _hoisted_38, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'kr'
          }]),
          onClick: _cache[10] || (_cache[10] = $event => langSelcet('kr'))
        }, _hoisted_41, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'jp'
          }]),
          onClick: _cache[11] || (_cache[11] = $event => langSelcet('jp'))
        }, _hoisted_44, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'ru'
          }]),
          onClick: _cache[12] || (_cache[12] = $event => langSelcet('ru'))
        }, _hoisted_47, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'ar'
          }]),
          onClick: _cache[13] || (_cache[13] = $event => langSelcet('ar'))
        }, _hoisted_50, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'nl'
          }]),
          onClick: _cache[14] || (_cache[14] = $event => langSelcet('nl'))
        }, _hoisted_53, 2)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};